module.exports = __webpack_public_path__ + "img/Ladylike-Glamour_fr.ead5049b.jpg";